import { SelectOption } from 'shared/form/models/SelectOption';
import { TipoUsuario } from 'user/models/Usuario';

export const FUNCIONALIDADES = {
  CONSULTA_CENTRO_COSTO:
    'Permite visualizar el organigrama con los centros de costos y tarjetas subordinados.',
  ABM_CENTRO_COSTO:
    'Permite crear un centro de costos y vincularlo a una cuenta, actualizar sus datos, darlo de baja, asi como también, mover un centro de costos que este por debajo en la jerarquia dentro del organigrama ',
  ABM_TARJETA:
    'Permite vincular o desvincular una tarjeta de cualquier centro de costos por debajo en la jerarquia',
  CONSULTA_CUENTA:
    'Permite consultar información, movimientos, liquidaciones, resúmenes, totales y saldo disponible de una cuenta por debajo en el organigrama de la empresa',
  ABM_USUARIO:
    'Permite crear un usuario, consultar los usuarios asociados a alguna cuenta del organigrama de la empresa, modificar los datos de un usuario y eliminar un usuario',
  ABM_USUARIO_BANCO:
    'Permite crear, listar, modificar y dar de baja usuarios de tipo BANCO',
  CONSULTA_TRANSFERENCIA:
    'Permite ver transferencias realizadas desde o hacia la cuenta del usuario',
  DISTRIBUCION:
    'Permite realizar una distribución de fondos a una cuenta visible dentro del organigrama de la empresa',
  CONSULTA_TARJETA:
    'Permite ver información, movimientos y autorizaciones de la tarjeta asociada a la cuenta del usuario',
  DEVOLUCION_TOTAL:
    'Permite realizar una devolución total de fondos hacia el centro de costos al cual se encuentra asociada la tarjeta',
  DEVOLUCION_PARCIAL:
    'Permite realizar una devolución parcial de fondos hacia el centro de costos al cual se encuentra asociada la tarjeta',
};

export const FUNCIONALIDADES_LABEL = {
  CONSULTA_CENTRO_COSTO: 'Consulta de Centro de Costos',
  ABM_CENTRO_COSTO: 'ABM de Centro de Costos',
  ABM_TARJETA: 'ABM de Tarjeta',
  ABM_USUARIO: 'ABM de Usuario',
  ABM_USUARIO_BANCO: 'ABM de usuarios BANCO',
  DISTRIBUCION: 'Distribución de fondos',
  CONSULTA_TARJETA: 'Consulta de Tarjeta',
  DEVOLUCION_TOTAL: 'Devolución total de fondos',
  DEVOLUCION_PARCIAL: 'Devolución parcial de fondos',
  CONSULTA_CUENTA: 'Consulta de Cuenta',
  CONSULTA_TRANSFERENCIA: 'Consulta de Transferencias',
};

export const CONSULTA_CENTRO_COSTO = 'CONSULTA_CENTRO_COSTO';
export const ABM_CENTRO_COSTO = 'ABM_CENTRO_COSTO';
export const ABM_TARJETA = 'ABM_TARJETA';
export const CONSULTA_CUENTA = 'CONSULTA_CUENTA';
export const ABM_USUARIO = 'ABM_USUARIO';
export const ABM_USUARIO_BANCO = 'ABM_USUARIO_BANCO';
export const CONSULTA_TRANSFERENCIA = 'CONSULTA_TRANSFERENCIA';
export const DISTRIBUCION = 'DISTRIBUCION';
export const CONSULTA_TARJETA = 'CONSULTA_TARJETA';
export const DEVOLUCION_TOTAL = 'DEVOLUCION_TOTAL';
export const DEVOLUCION_PARCIAL = 'DEVOLUCION_PARCIAL';

export const TARJETA = 'TARJETA';
export const CENTRO_COSTO = 'CENTRO_COSTO';

export const TIPO_USUARIO: SelectOption<TipoUsuario>[] = [
  { value: TARJETA, label: 'Tarjeta' },
  { value: CENTRO_COSTO, label: 'Centro de costo' },
];
